// extracted by mini-css-extract-plugin
module.exports = {"container":"row_container__1vgIh","column":"row_column__2KxHw","iconStyle":"row_iconStyle__45C7B","timeStyle":"row_timeStyle__FJ-3W","inForm":"row_inForm__2wYJJ"};